import AreasOfSpecialisationApi from '../../../../../core/api/AreasOfSpecialisationApi'

export const START_EDITING_PROFILE_APPROVAL_AREAS_OF_SPECIALISATION = 'START_EDITING_PROFILE_APPROVAL_AREAS_OF_SPECIALISATION'
export const STOP_EDITING_PROFILE_APPROVAL_AREAS_OF_SPECIALISATION = 'STOP_EDITING_PROFILE_APPROVAL_AREAS_OF_SPECIALISATION'
export const CANCEL_EDITING_PROFILE_APPROVAL_AREAS_OF_SPECIALISATION = 'CANCEL_EDITING_PROFILE_APPROVAL_AREAS_OF_SPECIALISATION'
export const ADVISER_PROFILE_APPROVAL_AREAS_OF_SPECIALISATION_PREFERENCES_FETCHED_AREAS_OF_SPECIALISATION = 'ADVISER_PROFILE_APPROVAL_AREAS_OF_SPECIALISATION_PREFERENCES_FETCHED_AREAS_OF_SPECIALISATION'
export const ADVISER_PROFILE_APPROVAL_AREAS_OF_SPECIALISATION_PREFERENCES_AREAS_OF_SPECIALISATION_SELECTED_CHANGED = 'ADVISER_PROFILE_APPROVAL_AREAS_OF_SPECIALISATION_PREFERENCES_AREAS_OF_SPECIALISATION_SELECTED_CHANGED'

const areasOfSpecialisationApi = new AreasOfSpecialisationApi()

export const startEditingAreasOfSpecialisation = () => ({
  type: START_EDITING_PROFILE_APPROVAL_AREAS_OF_SPECIALISATION
})

export const cancelEditingAreasOfSpecialisation = () => ({
  type: STOP_EDITING_PROFILE_APPROVAL_AREAS_OF_SPECIALISATION
})

export function fetchAreasOfSpecialisation () {
  const request = areasOfSpecialisationApi.fetchingAreasOfSpecialisation()

  return (dispatch) => {
    request.then(function (response) {
      dispatch(areasOfSpecialisationApi.handleResponse(ADVISER_PROFILE_APPROVAL_AREAS_OF_SPECIALISATION_PREFERENCES_FETCHED_AREAS_OF_SPECIALISATION, response))
    })
  }
}

export const areaOfSpecialisationSelectedChanged = (areaOfSpecialisation) => ({
  type: ADVISER_PROFILE_APPROVAL_AREAS_OF_SPECIALISATION_PREFERENCES_AREAS_OF_SPECIALISATION_SELECTED_CHANGED,
  areaOfSpecialisation
})

export const stopEditingAreasOfSpecialisation = () => ({
  type: STOP_EDITING_PROFILE_APPROVAL_AREAS_OF_SPECIALISATION
})

